import reqest from "../common/reqest";

/**
 * 观展门票列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getGzExhTicketList(data) {
  return reqest.send("/Subaccount/Gz_Exhticket_Lists", data);
}

/**
 * 参展门票列表
 * @param data
 * @returns {Promise<unknown>}
 */
export function getCzExhTicketList(data) {
  return reqest.send("/Subaccount/Cz_Exhticket_Lists", data);
}

/**
 * 参展门票增票
 * @param data
 * @returns {Promise<unknown>}
 */
export function getExhTicketGive(data) {
  return reqest.send("/Subaccount/Exhticket_Give", data);
}


/**
 * 参展票回收
 * @param data
 * @returns {Promise<unknown>}
 * @constructor
 */
export function ExhticketRecovery(data) {
  return reqest.send("/Subaccount/Exhticket_Recovery", data);
}